<template>
    <div>
      <page-head
        :title="title"
        :btn-list="btnList"
        :show-back="false"
        @handleBtn="handleBtn"
      ></page-head>
      <div class="content">
        <div class="search">
          <i-form ref="search" :model="query">
            <row :gutter="80">
              <i-col span="6">
                <form-item label="姓名" prop="XM">
                  <Input
                    v-model="query.XM"
                    clearable
                    placeholder="请输入姓名"
                    maxlength="10"
                  />
                </form-item>
              </i-col>
              <i-col span="6">
                <form-item label="身份证号" prop="GMSFZH">
                  <Input
                    v-model="query.GMSFZH"
                    clearable
                    placeholder="请输入身份证号"
                    maxlength="18"
                  />
                </form-item>
              </i-col>
            </row>
          </i-form>
        </div>
        <div class="table-data">
          <div class="bottomtable">
            <i-table
              :columns="tableHeader"
              :border="true"
              :loading="isLoading"
              :data="info"
              stripe
              ref="table"
              height="500"
            >
              <template slot-scope="{ row, index }" slot="action"> </template>
            </i-table>
          </div>
        </div>
      </div>
  
      <!-- <div class="content" v-if="info">
        <div class="search">
          <Form>
            <row :gutter="80" v-for="itme in info">
              <i-col span="8" v-for="(data, key) in itme">
                <FormItem :label="key + ':'">
                  <div class="detail">{{ data }}</div>
                </FormItem>
              </i-col>
            </row>
          </Form>
        </div>
      </div> -->
    </div>
  </template>
  
  <script>
  import pageHead from "../../../components/head";
  import api from "../../../api/index";
  const { swyxzmInfo } = api;
  export default {
    name: "marriageRegister",
    components: {
      pageHead,
    },
  
    data() {
      return {
        query: {
          GMSFZH: "",
          XM: "",
        },
        info: undefined,
        isLoading: false,
        tableHeader: [
            {title: "公民身份证号",key: "GMSFHM",align: "center"},
            {title: "姓名",key: "XM",align: "center"},
            {title: "性别代码",key: "XBDM",align: "center"},
            {title: "民族代码",key: "MZDM",align: "center"},
            {title: "死亡原因",key: "SWYY",align: "center"},
            // {title: "女方姓名",key: "女方姓名",align: "center"},
            // {title: "女方身份证件号码",key: "女方身份证件号码",align: "center"},
            // {title: "女方身份证件类型",key: "女方身份证件类型",align: "center"},
            // {title: "登记日期",key: "登记日期",align: "center"},
          //   {title: "原登记日期",key: "原登记日期",align: "center"},
        ],
        title: "死亡医学证明查询",
        btnList: [
          {
            name: "重置",
            type: "reset",
          },
          {
            name: "查询",
            type: "search",
          },
        ],
      };
    },
    methods: {
      handleBtn(type) {
        if (type == "reset") {
          this.query.XM = "";
          this.query.GMSFZH = "";
  
          this.$refs.search.resetFields();
        } else if (type == "search") {
          this.marriageRegister();
        }
      },
      async marriageRegister() {
        if (!this.query.XM) {
          return this.$Message.warning("请输入姓名");
        }
        if (!this.query.GMSFZH) {
          return this.$Message.warning("请输入身份证号");
        }
        this.isLoading = true;
        try {
          let data = {
            idCard: this.query.GMSFZH,
            userName: this.query.XM,
          };
          console.log(data);
          let res = await this.$get(swyxzmInfo, data);
          // res = '{"code":200,"message":"操作成功.","body":{"code":0,"message":"操作成功","data":[{"婚姻登记机关":"淇滨区民政局婚姻登记处","登记字号":"J410611-2016-002533","女方区划代码":"130203","男方姓名":"丁鹏","女方身份证件号码":"410926199006033621","女方身份证件类型":"内地居民身份证","业务类别":"结婚登记类","女方姓名":"吴宁","男方身份证件类型":"内地居民身份证","男方身份证件号码":"410927199203037011","原登记日期":null,"男方区划代码":"410611","登记日期":"2016-11-11"}],"messageId":null},"timestamp":0}'
          console.log(JSON.parse(res));
          if (res) {
            this.info = JSON.parse(res).body.data;
          } else {
            this.info = undefined;
          }
        } finally {
          this.isLoading = false;
        }
        console.log(this.query);
      },
    },
    created() {},
    mounted() {},
  };
  </script>
  
  <style lang="less" scoped>
  .content {
    margin: 20px;
  }
  
  .search {
    width: 100%;
    background-color: white;
    border-radius: 5px;
    padding: 20px;
    margin-bottom: 20px;
  }
  
  .label {
    width: 100px;
  }
  
  .time {
    width: 100%;
  }
  </style>
  